<template>
<!--  <el-cascader :props="props" clearable filterable :filter-method="handleFilter" @change="handleChange"></el-cascader>-->
  <el-radio-group v-model="value" >
    <el-cascader v-model="area" :props="props" clearable :filter-method="handleFilter" @change="handleChange"></el-cascader>
  </el-radio-group>
</template>

<script>
export default {
  name: "Area",
  data() {
    return {
      props: {
        lazy: true,
        checkStrictly: true
      },
      value: [],
      area: []
    }
  },
  created() {
    this.handleLoadArea();
    this.props['lazyLoad'] = this.lazyLoad;
  },
  methods: {
    handleChange(e) {
      this.$emit('change', e);
    },
    handleClear() {
      this.area = [];
    },

    lazyLoad(node, resolve) {
      const {data, level} = node;
      setTimeout(async () => {
        let areaData = [];
        if(data) {
          areaData = await this.handleLoadArea(data['number']);
        } else {
          areaData = await this.handleLoadArea();
        }
        const nodes = areaData.map(item => ({
              value: item,
              label: item.name,
              number: item.number,
              leaf: level >= 2
            }));
        resolve(nodes);
      }, 1000);
    },

    handleFilter(node, keyword) {
      console.log('node', node);
      console.log('keyword', keyword);
      return false;
    },

    // 请求
    async handleLoadArea(parentNumber) {
      const vm = this;
      let res = await vm.$http.get(vm.$api.common.loadArea, {params: {parentNumber}});
      if (res.data.status != 200) {
        vm.$message.error(res.data.desc);
        return;
      }
      return res.data.data['areaList'];
    }
  }
}
</script>

<style scoped>

</style>
